var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", width: "750" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "headline" },
            [
              _c(
                "v-flex",
                { attrs: { xs9: "" } },
                [
                  _c("v-icon", [_vm._v("done")]),
                  _vm._v("Validar programaciones ")
                ],
                1
              ),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  nativeOn: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-form",
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.save.apply(null, arguments)
                }
              },
              model: {
                value: _vm.valid,
                callback: function($$v) {
                  _vm.valid = $$v
                },
                expression: "valid"
              }
            },
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "" } },
                    [
                      _c(
                        "v-layout",
                        [
                          _c("v-flex", { attrs: { xs6: "" } }, [
                            _c("h4", [
                              _c("strong", [
                                _vm._v("Listado de servidores publicos")
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs6: "" } },
                            [
                              _c(
                                "v-menu",
                                {
                                  attrs: { "open-on-hover": "", buttom: "" },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "activator",
                                      fn: function(ref) {
                                        var on = ref.on
                                        return [
                                          _c("v-icon", _vm._g({}, on), [
                                            _vm._v("help_outline")
                                          ])
                                        ]
                                      }
                                    }
                                  ])
                                },
                                [
                                  _vm._v(" "),
                                  _c(
                                    "v-card",
                                    [
                                      _c(
                                        "v-card-text",
                                        { staticClass: "ayuda" },
                                        [
                                          _c(
                                            "v-layout",
                                            [
                                              _c(
                                                "v-flex",
                                                {
                                                  staticClass:
                                                    "text-xs-center caption"
                                                },
                                                [
                                                  _c("strong", [
                                                    _c(
                                                      "p",
                                                      [
                                                        _c("v-icon", [
                                                          _vm._v("help_outline")
                                                        ])
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c("p", [
                                                      _vm._v(
                                                        "Solo puede validar las programaciones"
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("p", [
                                                      _vm._v(
                                                        "cuando todos los servidores públicos"
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("p", [
                                                      _vm._v(
                                                        "del listado hayan enviado sus programaciones"
                                                      )
                                                    ])
                                                  ])
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-data-table", {
                                staticClass: "elevation-1",
                                attrs: {
                                  items: _vm.listado_funcionarios,
                                  "hide-actions": "",
                                  headers: _vm.headers
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "items",
                                    fn: function(props) {
                                      return [
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-center" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                props.item.servidor_publico
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-center" },
                                          [
                                            _c(
                                              "v-chip",
                                              {
                                                attrs: {
                                                  dark: "",
                                                  color:
                                                    props.item
                                                      .id_estado_vaca_progra ==
                                                    22
                                                      ? "#9637FF"
                                                      : props.item
                                                          .id_estado_vaca_progra ==
                                                        51
                                                      ? "#00DB15"
                                                      : props.item
                                                          .id_estado_vaca_progra ==
                                                        73
                                                      ? "#7ee06a"
                                                      : props.item
                                                          .id_estado_vaca_progra ==
                                                        74
                                                      ? "#73b6c4"
                                                      : props.item
                                                          .id_estado_vaca_progra ==
                                                        72
                                                      ? "#9d20b6"
                                                      : props.item
                                                          .id_estado_vaca_progra ==
                                                        70
                                                      ? "#c267a5"
                                                      : props.item
                                                          .id_estado_vaca_progra ==
                                                        69
                                                      ? "#9aed65"
                                                      : props.item
                                                          .id_estado_vaca_progra ==
                                                        68
                                                      ? "#6f9eb8"
                                                      : props.item
                                                          .id_estado_vaca_progra ==
                                                        67
                                                      ? "#83e0e3"
                                                      : props.item
                                                          .id_estado_vaca_progra ==
                                                        66
                                                      ? "#b0bed6"
                                                      : props.item
                                                          .id_estado_vaca_progra ==
                                                        65
                                                      ? "#c267be"
                                                      : props.item
                                                          .id_estado_vaca_progra ==
                                                        54
                                                      ? "#8f66b8"
                                                      : props.item
                                                          .id_estado_vaca_progra ==
                                                        58
                                                      ? "#88a7f5"
                                                      : props.item
                                                          .id_estado_vaca_progra ==
                                                        57
                                                      ? "#7c73c3"
                                                      : props.item
                                                          .id_estado_vaca_progra ==
                                                        56
                                                      ? "#64a054"
                                                      : props.item
                                                          .id_estado_vaca_progra ==
                                                        55
                                                      ? "#19afb4"
                                                      : "#FF3400"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    props.item
                                                      .id_estado_vaca_progra ==
                                                      22
                                                      ? "Creado"
                                                      : props.item.estado
                                                  )
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ])
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "error", loading: _vm.loading },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.close()
                        }
                      }
                    },
                    [
                      _c("v-icon", [_vm._v("close")]),
                      _vm._v("\n          Cancelar\n        ")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "primary",
                        disabled: !this.bandera_aprobacion
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.validarProgramacion()
                        }
                      }
                    },
                    [
                      _c("v-icon", [_vm._v("done")]),
                      _vm._v("\n          Validar\n        ")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-40d5dbb0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40d5dbb0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/vacaciones/dialogs/ValidarProgramacionJefeInmediato.vue
// module id = null
// module chunks = 